
import api from '../api';

/**
 * Confirm an order using the provided details.
 *
 * @param {string} orderId - The ID of the order to confirm.
 * @param {string} paymentMethod - The method used for payment.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const confirmOrder = async (orderID, paymentMethod) => {

  const requestData = {
    order_id: orderID,
    payment_method: paymentMethod,
  };

  try {

    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/order/confirm", requestData);
    return response.data;
  } catch (error) {
    console.error('Error while confirming order:', error);
    throw error;
  }
}

export default confirmOrder;
